import React, { Fragment, useEffect, useState } from 'react'
import { Breadcrumb, Card, Col, Container, CardBody, Button, CardHeader, Row } from 'reactstrap'
import AddEditDeliveryChargeModal from './AddEditDeliveryChargeModal';
import DataTable from "react-data-table-component";
import customAxios from '../../../customAxios';
import { toast } from "react-toastify";

const DeliveryChargesNew = () => {
    const [datas, setDatas] = useState([])
    const [open, setOpen] = useState(false);
    const [editData, setEditData] = useState(null);

    const getList = async () => {
        try {
            const response = await customAxios.get('admin/delivery-charges')
            setDatas(response?.data?.data || [])
        } catch (err) {
            toast.error(err?.response?.data?.message || err?.message || "Failed to fetch delivery charges");
        } 
    }

    useEffect(() => {
        getList()
    }, [])

    const onOpenModal = () => {
        setEditData(null);
        setOpen(true);
    };

    const onCloseModal = () => {
        setOpen(false);
        setEditData(null);
        getList();
    };

    const handleEdit = (row) => {
        setEditData(row);
        setOpen(true);
    };

    const Capitalize = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you wish to delete this item?")) {
            try {
                await customAxios.delete(`admin/delivery-charges/${id}`)
                const filtered = datas?.filter((res) => res?._id !== id);
                setDatas(filtered)
                toast.success(`Deleted Successfully`);
            } catch (err) {
                toast.error(err?.response?.data?.message || err?.message || "Failed to delete delivery charge");
            }
        }
    }

    var columns = [
        {
            name: <b>{Capitalize("S.No")}</b>,
            header: <b>{Capitalize("S.No")}</b>,
            cell: (row, index) => index + 1,
            width: "80px"
        },
        {
            name: <b>{Capitalize("Country")}</b>,
            header: <b>{Capitalize("Country")}</b>,
            selector: row => row?.country || "-",
            style: {
                textAlign: "center",
            },
        },
        {
            name: <b>{Capitalize("Min Order Amount")}</b>,
            header: <b>{Capitalize("Min Order Amount")}</b>,
            selector: row => row?.min_order_amount || "-",
            style: {
                textAlign: "center",
            },
        },
        {
            name: <b>{Capitalize("Delivery Charge")}</b>,
            header: <b>{Capitalize("Delivery Charge")}</b>,
            selector: row => row?.delivery_charge || "-",
            style: {
                textAlign: "center",
            },
        },
        {
            name: <b>Actions</b>,
            id: "actions",
            accessor: (str) => "actions",
            cell: (row, index) => (
                <>
                    <span onClick={() => handleEdit(row)} style={{ marginRight: "10px" }}>
                        <i
                            className="fa fa-edit"
                            style={{
                                width: 35,
                                fontSize: 20,
                                padding: 11,
                                color: "blue",
                                cursor: "pointer"
                            }}
                        ></i>
                    </span>
                    <span onClick={() => handleDelete(row._id)}>
                        <i
                            className="fa fa-trash"
                            style={{
                                width: 35,
                                fontSize: 20,
                                padding: 11,
                                color: "#e4566e",
                                cursor: "pointer"
                            }}
                        ></i>
                    </span>
                </>
            ),
            width: "120px"
        }
    ];

    return (
        <Fragment>
            <Breadcrumb title="Delivery Charges" parent="Settings" />
            <Container fluid="true">
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader>
                                <h5>Delivery Charges</h5>
                            </CardHeader>
                            <CardBody>
                                <div className="btn-popup pull-right">
                                    <Button
                                        type="button"
                                        color="secondary"
                                        onClick={onOpenModal}
                                        data-toggle="modal"
                                        data-original-title="test"
                                        data-target="#exampleModal"
                                    >
                                        Add Delivery Charge
                                    </Button>
                                </div>
                                <div className="clearfix"></div>
                                <div id="basicScenario" className="product-physical">
                                    <DataTable
                                        pagination
                                        columns={columns}
                                        data={datas}
                                        fixedHeader
                                        subHeader
                                    />
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            {open && (
                <AddEditDeliveryChargeModal
                    openModal={open}
                    editData={editData}
                    onCloseModal={onCloseModal}
                    title={editData ? "Edit Delivery Charge" : "Add Delivery Charge"}
                />
            )}
        </Fragment>
    )
}

export default DeliveryChargesNew

